import React, {Component} from 'react';
import autobind from 'autobind-decorator';
import {FormControl, FormGroup} from 'react-bootstrap';

export class ConservationActionPhaseFilter extends Component {
    @autobind
    updateValue(x) {
        const { UpdateValue } = this.props;
    
        if(UpdateValue) {
            UpdateValue(x.target.value);
        }
    }

    render() {
        const { Value, HideUnselectedOption, ConservationActionPhases } = this.props;
        const placeholder = "Phase Type";

        return <FormGroup controlId="formControlsSelect">
            <FormControl
                as="select"
                placeholder={placeholder}
                value={Value ? Value : ""}
                onChange={this.updateValue}
            >
                {
                    !HideUnselectedOption ?
                        <option value={""}>{placeholder}</option>:
                        null
                }
                {
                    ConservationActionPhases.map((x, index) => {
                        return <option
                            key={index}
                            value={index}
                        >
                            {x.name}
                        </option>;
                    })
                }
            </FormControl>
        </FormGroup>
    }
}


